import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReportPreviewDialogComponent } from '../shared/report-preview-dialog/report-preview-dialog.component';
import { Invoice, Quote, Statement } from './model/entity-model';
import { AuthService, BrewersUnitOfWork } from './core.module';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    modalService = inject(BsModalService);
    sanitizer = inject(DomSanitizer);

    static serviceName: string;

    constructor() {
        ReportService.serviceName = `${environment.serviceName}/report`;
    }

    async printInvoiceReport(invoice: Invoice) {
        if (!invoice.invoiceCode) {
            invoice.invoiceCode = crypto.randomUUID();
            await this.uow.commit([invoice]);
        }

        window.open(`${ReportService.serviceName}/invoiceReport?invoiceCode=${invoice.invoiceCode}`, '_blank');
    }

    async printQuoteReport(quote: Quote) {
        if (!quote.quoteCode) {
            quote.quoteCode = crypto.randomUUID();
            await this.uow.commit([quote]);
        }

        window.open(`${ReportService.serviceName}/quoteReport?quoteCode=${quote.quoteCode}`, '_blank');
    }

    async printRequest(invoices: Invoice[]) {
        const printRequest = this.uow.printRequests.createEntity({
            printRequestCode: crypto.randomUUID(),
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        });
        const printRequestInvoices = [];
        invoices.forEach((invoice) => {
            if (!invoice.invoiceCode) invoice.invoiceCode = crypto.randomUUID();

            printRequestInvoices.push(
                this.uow.printRequestInvoices.createEntity({
                    printRequestId: printRequest.id,
                    invoiceId: invoice.id,
                })
            );
        });
        await this.uow.commit([printRequest, ...printRequestInvoices, ...invoices]);

        window.open(`${ReportService.serviceName}/printRequest?printRequestCode=${printRequest.printRequestCode}`, '_blank');
    }

    async printStatement(customerIds: number[]) {
        const statement = this.uow.statements.createEntity({
            code: crypto.randomUUID(),
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
            customerIds: customerIds.join(','),
        });
        await this.uow.commit([statement]);

        this.viewStatement(statement);
    }

    viewStatement(statement: Statement) {
        const pdfUrl = statement.filename || `${ReportService.serviceName}/statementReport?statementCode=${statement.code}`;

        this.modalService.show(ReportPreviewDialogComponent, {
            class: 'modal-xl',
            initialState: {
                title: statement.name || 'Statement',
                url: this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl),
            },
        });
    }
}
